/**
 * Small client adapter for the Rails I18n catalog embedded by the layouts.
 * @param {string} key
 * @param {string} fallback
 * @param {Record<string, string | number>} replacements
 */
export function t(key, fallback, replacements = {}) {
  const template = (typeof window !== "undefined" && window.ReadcrumbsI18n?.[key]) || fallback
  return Object.entries(replacements).reduce(
    (copy, [name, value]) => copy.replaceAll(`%{${name}}`, String(value)),
    template,
  )
}
